(function (Drupal) {
  Drupal.behaviors.mediaTextSlider = {
    attach: function (context) {

      document.querySelectorAll('[id^="mts-mobile-slider-"]').forEach((sliderEl) => {

        const paragraphId = sliderEl.id.replace('mts-mobile-slider-', '');

        const tabsWrapper = document.querySelector('#mediaTextSliderTab-' + paragraphId);
        const panesWrapper = document.querySelector('#mediaTextSliderTabContent-' + paragraphId);

        if (!tabsWrapper || !panesWrapper) return;

        // Init Splide for this paragraph only
        const splide = new Splide(sliderEl, {
          type: 'slide',
          perPage: 2,
          focus: 'center',
          trimSpace: false,
          pagination: false,
          arrows: false,
          drag: true,
          gap: '1rem',
          rewind: true,
          speed: 400,
          breakpoints: {
            460: {
              gap: '0.5rem',
            }
          }
        }).mount();

        // MOBILE → DESKTOP (swipe changes tab)
        splide.on('move', function (newIndex) {
          const tabTrigger = tabsWrapper.querySelector(
            `button[data-bs-target="#mts-${paragraphId}-pane-${newIndex}"]`
          );

          if (tabTrigger) {
            const tab = new bootstrap.Tab(tabTrigger);
            tab.show();
          }
        });


        // DESKTOP → MOBILE (tab changes slide)
        tabsWrapper.querySelectorAll('button').forEach((btn, index) => {
          btn.addEventListener('shown.bs.tab', () => {
            splide.go(index);
          });
        });

        // CLICK ON SLIDE → select slide + sync tab (Tesla style)
        sliderEl.querySelectorAll('.splide__slide').forEach((slide, index) => {
          slide.addEventListener('click', () => {
            splide.go(index);

            const tabTrigger = tabsWrapper.querySelector(
              `button[data-bs-target="#mts-${paragraphId}-pane-${index}"]`
            );

            if (tabTrigger) {
              const tab = new bootstrap.Tab(tabTrigger);
              tab.show();
            }
          });
        });

        // Highlight active slide
        splide.on('moved', (newIndex) => {
          sliderEl.querySelectorAll('.splide__slide').forEach((sl, i) => {
            sl.classList.toggle('is-active', i === newIndex);
          });
        });
      });
    }
  };
})(Drupal);
